export const priceGroupSelectionBasedOnTheSelectedFabricError =
  'Oops! We detected an issue with the current configuration. This fabric might not be available in M3 for the configured product. Please try another option or contact customer service for assistance.';
